const sendLoginPortalCallBack = async (
  identifiant,
  password,
  external_id,
  prefix
) => {
  let url = prefix + `dpe/callback`;
  let headers = {
    "Content-Type": "application/json",
  };

  let body = {
    identifiant: identifiant,
    password: password,
    external_id: external_id,
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    // Check if the request was successful
    if (response.ok) {
      // Handle successful response
      return true;
    } else {
      // Handle error response
      console.error(`Exception occurred: ${response.status}`);

      return false;
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return false;
  }
};

export default sendLoginPortalCallBack;
